import React from 'react';
import AuthService from './authService.js';
import OpenAiChatSessionItem from '../Domain/OpenAiChatSessionItem.js';
import OpenAiChatMessageItem from '../Domain/OpenAiChatMessageItem.js';
import EndOfMonthItem from '../Domain/EndOfMonthItem.js';

export default class OpenAiChatSessionService extends React.Component {
  static GetSessionList() {
    const authService = AuthService.getInstance();
    let url = '/api/OpenAiChat/GetSessions';
    url += '?clearCache=true';
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new OpenAiChatSessionItem(item));
    }
    return [];
  }

  static ConvertMessageItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new OpenAiChatMessageItem(item));
    }
    return [];
  }

  static CreateNewSession() {
    const authService = AuthService.getInstance();
    const url = '/api/OpenAiChat/CreateNewSession';
    return authService.CallBackendFunctionPost(url);
  }

  static SendMessage(data) {
    const authService = AuthService.getInstance();
    const url = '/api/OpenAiChat/GetResponseForMessage';
    const jsonData = JSON.stringify(data);
    return authService.CallBackendFunctionPost(url, jsonData);
  }

  static GetSessionMessagesList(id) {
    const authService = AuthService.getInstance();

    let url = '/api/OpenAiChat/GetSessionMessagesById/' + id;
    url += '?clearCache=true';
    return authService.CallBackendFunction(url);
  }
}
